//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export const MM_DD_YYYY = 'MMMM DD, YYYY';

export const DATE_FORMAT_MMM_DD_YYYY = 'MMM DD, YYYY';

export const DATE_FORMAT_MM_DD_YYYY = 'MM/DD/YYYY';

export const DATE_FORMAT_FULL = 'MMMM D, YYYY [at] h:mm A';

export const DATE_FORMAT_FULL_FILENAME = 'YYYY_MM_DD_HH_mm_ss';
